export default __webpack_public_path__ + "static/media/thanksgiving-banner.02fe078d.jpg";